import { setExpanded } from '../utils/dom'

let filterController = null

export default function initFilter() {
	filterController?.abort()
	filterController = new AbortController()
	const { signal } = filterController

    const filters = document.querySelectorAll('.filter')

    filters.forEach(filter => {
        const toggle = filter.querySelector('.filter__toggle')
        const dropdown = filter.querySelector('.filter__list')

        if (!toggle || !dropdown) return

		const setOpen = (isOpen) => {
			filter.classList.toggle("is-open", isOpen)
			setExpanded(toggle, isOpen)
		}

        // Set toggle width
        function setToggleWidth() {
            toggle.style.setProperty('--toggle-width', dropdown.offsetWidth + 'px')
        }
        setToggleWidth()
        window.addEventListener("resize", setToggleWidth, { signal })

        // Toggle dropdown open/close
        toggle.addEventListener("click", (e) => {
            e.stopPropagation()
            setOpen(!filter.classList.contains("is-open"))
        }, { signal });

		toggle.addEventListener("keydown", (e) => {
			if (e.key !== 'ArrowDown') return

			e.preventDefault()
			setOpen(true)
			dropdown.querySelector("a")?.focus()
		}, { signal })

        // Close if clicking outside
        document.addEventListener("click", (e) => {
            const clickedInsideDropdown = dropdown.contains(e.target)
            const clickedToggle = toggle.contains(e.target)

            if (!clickedInsideDropdown && !clickedToggle) {
                setOpen(false)
            }
        }, { signal })

		document.addEventListener("keydown", (e) => {
			if (e.key === 'Escape') {
				setOpen(false)
			}
		}, { signal })

        // Close if window resized
        window.addEventListener("resize", () => {
            setOpen(false)
        }, { signal })

        // Close if clicking a link inside
        dropdown.querySelectorAll("a").forEach(link => {
            link.addEventListener("click", () => {
                setOpen(false)
            }, { signal })
        })

		setOpen(false)
    })
}
